import { PureComponent } from 'preact-compat'

export interface ReplyPillsProps {
  trashed: boolean
  spam: boolean
  pending: boolean
  author?: boolean
  replyNumber: number
  replyCount: number
  pinned?: boolean
}

class ReplyPills extends PureComponent<ReplyPillsProps> {
  render() {
    const { trashed, spam, replyNumber, replyCount, pinned, pending, author } = this.props
    return (
      <div className='pull-right pill-container'>
        {spam && <span className='pill pill--spam'>spam</span>}
        {pending && <span className='pill pill--pending'>pending</span>}
        {trashed && <span className='pill pill--trashed'>trashed</span>}
        {pinned && !trashed && <span className='pill pill--pin'>pin</span>}
        {author && !trashed && <span className='pill pill--author'>author</span>}
        <span className='pill pill--counter'>{replyNumber} of {replyCount}</span>
      </div>
    )
  }
}

export default ReplyPills
